import React, { useContext } from 'react';
import { Message } from 'semantic-ui-react';
import UserContext from '../../../contexts/UserContext';
import { useFacility } from '../../contexts/facility/FacilityContext';
import LinksList, { AppLink } from '../../components/LinksList';

const extractAppLinks = (facilityData: Record<string, unknown> | null): AppLink[] => {
    const appLinks = (facilityData?.customAppInfo as { appLinks?: unknown } | undefined)?.appLinks;
    return Array.isArray(appLinks) ? appLinks : [];
};

const Links = () => {
    const {
        userObject: {
            registrants: { list: listOfResidents, activeRegistrantsIndexes },
        },
    } = useContext(UserContext);

    const activeResident = listOfResidents[activeRegistrantsIndexes[0]];
    const { facilityDetails, loading } = useFacility();
    const links = extractAppLinks(facilityDetails);

    if (!activeResident) {
        return <Message content="Invalid user. Please contact support." />;
    }

    return <LinksList links={links} loading={loading} />;
};

export default Links;
